import React from "react";
import Link from "next/link";
import { Application } from "../utils/model";
import Thumbnail from "/global-layout/global-components/thumbnail";
import { FaDownload } from "react-icons/fa6";

var md5 = require("md5");

export interface iProps {
  app: Application;
  category?: string;
  parent_category?: string;
  subcategory?: string;
  platform?: string;
  classes?: string;
  maxWidth?: string;
  maxChar?: number;
  order?: number;
}

const ApplicationHorizontalListItem = (props: iProps) => {
  const app = props.app;
  if (!app) {
    return;
  }
  let imagePath = app.icon ? app.icon?.url : "";

  return (
    <li className="desktopListitem m-4 grow list-none flex items-center border-b border-slate-300 pb-4">
      <div className="p-2 max-w-[30px] h-full mr-3 shrink-0 grow flex items-center">
        <div>{props.order}</div>
      </div>
      <Link
        href={`/${app.platform?.name?.toLowerCase()}/${props.parent_category}/${
          app.parent_category?.slug
        }/${app.slug}`}
        title={app.title}
      >
        <div className="thumbnail bg-white flex items-center justify-center overflow-hidden aspect-square relative w-18 sm:w-24 rounded-md border border-slate-400 text-center">
          {
            <Thumbnail
              appName={app.icon?.alternativeText || app.title}
              imagePath={imagePath}
              classes="max-w-[54px] max-h-[54px]"
              index={props.order}
            />
          }
        </div>
      </Link>

      <div className="title text-sm md:text-lg mx-4 w-[28%] grow text-left flex flex-col">
        <Link
          title={app.title}
          href={`/${app.platform?.name?.toLowerCase()}/${
            props.parent_category
          }/${app.parent_category?.slug}/${app.slug}`}
        >
          <span className="md:text-base lg:text-lg">{app.title}</span>
        </Link>
        <div className="hidden text-sm md:inline-block">
          {app.excerpt.substring(0, 60) + "..."}
        </div>
      </div>
      <div className="title text-sm sm:text-lg text-left mx-4 grow min-w-[88px] flex justify-center flex-row items-center">
        <FaDownload className="inline-block h-3 text-left" />
        {app.totalDownloads && app.totalDownloads}
        <span className="hidden md:inline-block">&nbsp;Downloads</span>
      </div>
      <div className="w-16 h-16 md:w-24 md:h-24">
        <Link
          title={`Download ${app.title}`}
          href={`/${app.platform?.name?.toLowerCase()}/${
            props.parent_category
          }/${app.parent_category?.slug}/${app.slug}`}
          className="flex h-full w-22 align-middle justify-center items-center rounded-md bg-getjar-green"
        >
          <FaDownload
            className="h-4 aspect-square w-4 md:h-10 md:w-10"
            fill="white"
          />
        </Link>
      </div>
    </li>
  );
};

export default ApplicationHorizontalListItem;
